import { render, staticRenderFns } from "./MessagesPage.vue?vue&type=template&id=73ad0aad&scoped=true&"
import script from "./MessagesPage.vue?vue&type=script&lang=js&"
export * from "./MessagesPage.vue?vue&type=script&lang=js&"
import style0 from "./MessagesPage.vue?vue&type=style&index=0&id=73ad0aad&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73ad0aad",
  null
  
)

export default component.exports